import { IssueTypeIconName } from "../../assets/issue-type-svgs.tsx";

import { ListIssueType } from "./list-issue-types.tsx";

export const fillOrTrimIcons = (
    icons: IssueTypeIconName[],
    maxCount: number
) => {
    if (icons.length >= maxCount) return icons.slice(0, maxCount);
    const filler = icons[0] || "Task";
    return [...icons, ...Array(maxCount - icons.length).fill(filler)];
};

export const getListIssueTypeDynamicView = (
    issueTypeIcons: IssueTypeIconName[]
) => {
    const iconsToBePlaced = fillOrTrimIcons(
        issueTypeIcons,
        issueTypeIcons.length
    );
    return <ListIssueType issueTypeIcons={iconsToBePlaced} />;
};
